(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hmu-etsy-reviews"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-etsy-carousel]').forEach(root=>{const track=root.querySelector('.hmu-etsy-track');const prev=root.querySelector('[data-etsy-prev]');const next=root.querySelector('[data-etsy-next]');if(!track||!prev||!next)return;const update=()=>{prev.disabled=track.scrollLeft<3;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-3;};const move=direction=>{const card=track.querySelector('li');if(card)track.scrollBy({left:direction*(card.getBoundingClientRect().width+22),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});new ResizeObserver(update).observe(track);update();});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hmu-new-arrivals"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (root) => {
    root.querySelectorAll('[data-hmu-arrivals]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const list = section.querySelector('.hmu-arrivals-cards');
      const controls = section.querySelector('.hmu-arrivals-controls');
      const previous = section.querySelector('[data-arrivals-prev]');
      const next = section.querySelector('[data-arrivals-next]');
      const update = () => {
        controls.hidden = list.scrollWidth <= list.clientWidth + 2;
        previous.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
      };
      const move = (direction) => {
        const card = list.querySelector('.hmu-arrivals-card');
        list.scrollBy({left: direction * (card.getBoundingClientRect().width + 18), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      list.addEventListener('scroll', update, {passive:true});
      list.addEventListener('keydown', (event) => {
        if (event.target === list && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      window.addEventListener('resize', update, {passive:true});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hmu-product-personalization"] && !Shopify.designMode) return;
  try {
    function hmuSyncAnklet(form){const groups=form.querySelectorAll('[data-hmu-anklet]');if(!groups.length)return;const threePiece=Array.from(form.querySelectorAll('.single-option-selector')).some(select=>select.value.toLowerCase().includes('3pc'));groups.forEach(group=>{group.hidden=!threePiece;group.querySelectorAll('input,select').forEach(input=>{input.disabled=!threePiece;});});}
document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('form').forEach(hmuSyncAnklet);});
document.addEventListener('change',event=>{const input=event.target;if(input.form)hmuSyncAnklet(input.form);if(!input.matches('[data-hmu-photo]'))return;const file=input.files[0];const allowed=['image/jpeg','image/png','image/webp'];input.setCustomValidity(file&&(!allowed.includes(file.type)||file.size>10*1024*1024)?input.dataset.fileError:'');input.reportValidity();});
document.addEventListener('submit',event=>{const form=event.target;if(!(form instanceof HTMLFormElement)||!form.querySelector('[data-hmu-personalization]'))return;event.preventDefault();event.stopImmediatePropagation();hmuSyncAnklet(form);form.querySelectorAll('[data-hmu-text]').forEach(input=>{input.value=input.value.trim();});if(!form.reportValidity())return;const button=form.querySelector('[data-add-to-cart]');if(button&&button.getAttribute('aria-disabled')==='true')return;HTMLFormElement.prototype.submit.call(form);},true);
  } catch(e) { console.error(e); }
})();

})();
